import { render, staticRenderFns } from "./SlotRecordList.vue?vue&type=template&id=322aa81c&scoped=true"
import script from "./SlotRecordList.vue?vue&type=script&lang=js"
export * from "./SlotRecordList.vue?vue&type=script&lang=js"
import style0 from "./SlotRecordList.vue?vue&type=style&index=0&id=322aa81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322aa81c",
  null
  
)

export default component.exports